<template>
    <div class="firstRechargePage">
    <CustomHeader :text="$t('activityName.first_recharge')" :show-history="true" @openHistoryPopup="openHistoryPopup" />
    <img class="bg-top-img" :src="dataSet.bannerIcon">
    <div class="firstRecharge">
        <div class="firstRecharge-left">
            <img src="@/assets/firstRecharge/walletFR.png" class="wallet-icon" />
            <span class="firstRecharge-label">{{ $t('activity.firstRecharge') }}:</span>
        </div>
        <span class="firstRecharge-amount">R$ {{ formatCurrency(dataSet.firstRechargeAmount) }}</span>
    </div>
    <div class="container">
        <img v-if="dataSet.showLeft" src="@/assets/home/game_arrow_white.png"
            style="width: 5%;position: absolute;top: 2vh; z-index: 200;" @click="scrollLeft">
        <img v-if="dataSet.showRight" src="@/assets/home/game_arrow_white.png" @click="scrollRight"
            style="width: 5%;position: absolute;transform: rotate(180deg);right:0;top: 2vh; z-index: 200;">
        <div v-if="dataSet.recordList.length > 0">
            <div class="content">
                <div v-for="(i, index) in dataSet.recordList" :key="index" class="image-wrapper">
                    <DayListFirst :currenyLable="true" :valueOne="i?.coin" :valueTwo="i?.turnover"
                        :labelOne="'dayList.giftAmount'" :labelTwo="'dayList.turnoverTimes'" :activityStatus="i?.status"
                        :time="i?.rewardDate" @getClaim="getClaim" :available-amount="i?.availableAmount"
                        :given-amount="i?.givenAmount" />
                </div>
            </div>
        </div>
        <div class="tabs-container" v-if="dataSet.firstRechargeConfig">
            <van-tabs v-if="dataSet.isShowTabs" v-model:active="active" :ellipsis="false" ref="tabsRef"
                @rendered="checkScroll">
                <van-tab v-for="(item, index) in dataSet.firstRechargeConfig?.config" :key="index" :title="item.title"
                    :name="index">
                    <div class="content">
                        <div class="immidiateDepositBtn"  v-if="dataSet.firstRechargeConfig?.firstRechargeEligible">
                            <div class="depositBtn" @click="goToDeposit(item.amount)">
                                <img src="@/assets/firstRecharge/DepoBtnFR.png" class="btn-icon-image" />
                                <span class="btn-text">{{ $t('activity.immediateDeposit') }} : {{ item.amount }}</span>
                                <van-icon name="arrow" class="arrow-right" />
                            </div>
                        </div>
                        <div v-for="(i, index) in item.days" :key="index" class="image-wrapper">
                            <DayListFirst :currenyLable="true" :day="i.day" :valueOne="i.gift ? i.gift : 0"
                                :valueTwo="i.turnover_times" :labelOne="'dayList.giftAmount'"
                                :labelTwo="'dayList.turnoverTimes'" :activityStatus="i.activeStatus" />
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
            <div v-else v-for="(item, index) in dataSet.firstRechargeConfig?.config" :key="index" :title="item?.title"
                :name="index">
                <div class="content">
                    <div v-for="(i, index) in item?.days" :key="index" class="image-wrapper">
                        <DayListFirst :currenyLable="true" :day="i?.day" :valueOne="i?.gift ? i?.gift : 0"
                            :valueTwo="i?.turnover_times" :labelOne="'dayList.giftAmount'"
                            :labelTwo="'dayList.turnoverTimes'" :activityStatus="i?.activeStatus" />
                    </div>
                </div>
            </div>
        </div>
        <NoData v-if="!dataSet.firstRechargeConfig && dataSet.recordList.length == 0" />
        <div class="bottom_text">
            <van-row style="padding-bottom: 10px;">
                <van-col span="6">
                </van-col>
                <van-col span="12" class="title">
                    <div>{{ $t('common.activityTitle') }}</div>
                </van-col>
                <van-col span="6">
                </van-col>
            </van-row>
            <div class="line_text" v-for="(item, index) in dataSet.formattedMessages" :key="index" v-html="item">
            </div>
        </div>
        <CashbackHistoryPopup ref="histryPopupRef" :list="dataSet.historyList" :title="$t('activity.lossTotal')"
            @resetHistoryData="resetHistoryData" :isUseFirstRecharge="true" :isTabsContainerActive="dataSet.isShowTabs" />
    </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { formatCurrency } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import DayListFirst from './components/dayListFirst.vue';
import NoData from '../components/common/noData.vue';
import CashbackHistoryPopup from './components/cashbackHistoryPopup.vue';
import { FirstRechargeData } from '@/view/firstRecharge/supportScript';

const histryPopupRef = ref()
const active = ref(0);
const props = defineProps<{
    dataSet: FirstRechargeData
}>()

const emits = defineEmits(['checkScroll', 'scrollLeft', 'scrollRight', 'getClaim', 'goToDeposit'])

const setActive = (value : number) => {
    active.value = value
}

const checkScroll = () => {
    emits('checkScroll')
};

const scrollLeft = () => {
    emits('scrollLeft')
};

const scrollRight = () => {
    emits('scrollRight')
};

const getClaim = () => {
    emits('getClaim')
}
const goToDeposit = (amount : any) => {
     emits("goToDeposit", amount)
}

const openHistoryPopup = (data: any) => {
    histryPopupRef.value.open(data)
}
const resetHistoryData = () => {
    // historyList.value = []
}
defineExpose({
    setActive
})
</script>
<style scoped>
.firstRechargePage {
    background-color: #0b0504;
    min-height: 100vh;
}

.firstRecharge {
    margin: 10px 15px;
    padding: 15px 15px;
    background: linear-gradient(180deg, #2e2420 0%, #130f0f 100%);
    border: 1px solid rgba(214, 163, 119, 0.6);
    box-shadow: 0 0 5px rgba(255, 215, 0, 0.2); 
    animation: pulse 2s infinite;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 10;
}

.firstRecharge-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.wallet-icon {
    width: 36px;
    height: auto;
}

.firstRecharge-label {
    color: #cccccc;
    font-size: 14px;
}

.firstRecharge-amount {
    color: #f2bc94;
    font-size: 20px;
    font-weight: bold;
}

.container {
    padding: 0px;
    position: relative;

}

.tabs-container {
    margin: 0 15px 20px;
    border: 1px solid rgba(230, 184, 138, 0.3); 
    border-radius: 12px;
    background: rgba(19, 15, 15, 0.65); 
    overflow: hidden;
    backdrop-filter: blur(4px); 
}

.tabs-container>>>.van-tabs__nav {
    background: rgba(30, 30, 30, 0.4); 
    margin: 0;
    padding: 0;
}

.tabs-container>>>.van-tab {
    background: transparent;
    color: #9a8a77;
    border-radius: 0;
    font-size: 14px;
    margin: 0;
    height: 48px;
    padding: 0;
    flex: 1;
    border-bottom: 1px solid rgba(214, 163, 119, 0.2);
}

.tabs-container>>>.van-tab.van-tab--active {
    color: #e6b88a;
    font-weight: bold;
    border-radius: 8px 8px 0 0;
    border: 1px solid rgba(212, 166, 126, 0.4);
    border-bottom: none;
    position: relative;
    box-shadow: 
        inset 2px 20px 20px 2px rgba(230, 184, 138, 0.3),
        inset 0px 1px 20px -50px rgba(230, 184, 138, 0.15);
}

.tabs-container>>>.van-tab.van-tab--active::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    height: 2px;
    background: linear-gradient(90deg, transparent 0%, #e6b88a 50%, transparent 100%);
    border-radius: 1px;
}
.tabs-container>>>.van-tabs__line {
    background-color: #e6b88a;
    height: 2px;
    width: 30px !important;
    bottom: 6px;
    border-radius: 2px;
}

.content {
    color: #fff;
    padding: 15px;
}

.tabs-container .content {
    background: transparent;
}

.immidiateDepositBtn {
    margin-bottom: 15px;
}

.depositBtn {
    background: linear-gradient(90deg, #fcdbb0 0%, #dda270 100%);
    border-radius: 12px;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

.btn-icon-image {
    width: 32px;
    height: 32px;
    object-fit: contain;
}

.btn-text {
    flex: 1;
    margin-left: 12px;
    text-align: left;
    color: #222;
    font-size: 15px;
    font-weight: bold;
}

.arrow-right {
    font-size: 18px;
    color: #222;
    font-weight: bold;
}
.bottom_text {
    margin: 0 15px 20px;
    padding: 15px 20px;
    background: linear-gradient(1deg, #1e1816 0%, #0b0504 100%);
    border-radius: 12px 12px 0 0;
    box-shadow: 0 0 8px rgba(255, 215, 0, 0.1);
}

.title {
    color: #ebd3c1d9;
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(229, 195, 170, 0.45);
    font-size: 14px;
    padding: 10px;
}

.bg-top-img {
    width: 100%;
    padding-top: 3rem;
}

.scroll-btn {
    position: absolute;
    font-size: 24px;
    color: white;
    cursor: pointer;
    z-index: 1000;
    border-radius: 50%;
    user-select: none;

}

.scroll-btn img {
    width: 10%;
    z-index: 200;
}

.scroll-btn.left {
    left: 50vw;
    width: 4%;
}

.scroll-btn.right {
    right: 0;
}

.right img {
    transform: rotate(180deg) !important;
}

@media (max-width: 360px) {
    .firstRecharge-amount {
        font-size: 15px;
    }
    .title {
        font-size: 13px;
    }
}
</style>